// Source: app/scripts/directives/base-entity.js
/**
 * Created by riste_000 on 3/15/2015.
 */


Auction.directive('baseEntity', [
  '$compile',
  '$templateCache',
  '$http',
  'settings',
  function($compile, $templateCache, $http, settings) {
    return {
      restrict: 'EA',
      scope: {
        entityClass: '=',
        entity: '=',
        type: '@',
        actions: '=',
        close: '='
      },
      template: '<div></div>',
      link: function(scope, element, attrs) {

        scope.$watch('entity._class', function(value) {
          if(value) {
            loadTemplate(value, scope.type);
          }
        });

        scope.$watch('entityClass', function(value) {
          if(value) {
            loadTemplate(value, scope.type);
          }
        });

        function loadTemplate(template, type) {
          var path = 'entities/' + template + (type ? '.' + type : '') + '.html?version=' + settings.version;
          $http.get(path, {cache: $templateCache})
            .success(function(templateContent) {
              element.html('');
              element.append($compile(templateContent)(scope));
            });
        }

        var name = scope.entityClass || (scope.entity && scope.entity._class);
        if(name) {
          loadTemplate(name, scope.type);
        }
      }
    };
  }]);
